export default __webpack_public_path__ + "static/media/center_white.e30df34f.svg";